module.exports = __webpack_public_path__ + "static/media/Credit_Card_Logos@3x.f4ec4a49.png";